import { Record } from 'immutable';
import { createReducer } from 'app/utils/redux';
import {
  CALL_TAB_CONTENT,
  SET_TAB,
  SET_NAVIGATION_ERROR,
  INC_IN_CONTENT_VIDEOS_PRESENT,
  DEC_IN_CONTENT_VIDEOS_PRESENT,
  INC_IN_CONTENT_VIDEOS_VISIBLE,
  DEC_IN_CONTENT_VIDEOS_VISIBLE,
} from 'app/models/ui/call/constants';

const CallState = Record({
  tab:                     CALL_TAB_CONTENT,
  inContentVideosPresent:  0,
  inContentVideosVisible:  0,
  inContentSidebarPresent: false,
  showUnsupportedMessage:  false,
  navigationError:         null,
}, 'CallState');

const reducer = createReducer(new CallState(), {
  [SET_TAB]: (state, { payload }) => state.set('tab', payload),
  [SET_NAVIGATION_ERROR]: (state, { payload }) => state.set('navigationError', payload),

  [INC_IN_CONTENT_VIDEOS_PRESENT]: state => state.update('inContentVideosPresent', x => x + 1),
  [DEC_IN_CONTENT_VIDEOS_PRESENT]: state => state.update('inContentVideosPresent', x => x - 1),
  [INC_IN_CONTENT_VIDEOS_VISIBLE]: state => state.update('inContentVideosVisible', x => x + 1),
  [DEC_IN_CONTENT_VIDEOS_VISIBLE]: state => state.update('inContentVideosVisible', x => x - 1),
});

export default reducer;
